import { EventsName } from '../constants'

const renewTokenEventDispatch = () => {
  window.dispatchEvent(new CustomEvent(EventsName.RENEW))
}
const renewTokenEventListener = (listener: () => void) => {
  window.addEventListener(EventsName.RENEW, listener)

  return () => {
    window.removeEventListener(EventsName.RENEW, listener)
  }
}

export { renewTokenEventDispatch, renewTokenEventListener }
